export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== "/200") return;

  return navigateTo("/referrals");
});
